// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__ChFsT","header":"PatientQuestionnaire_header__1vkkF","info":"PatientQuestionnaire_info__yTuK6"};